import { render, staticRenderFns } from "./ImagePopinHeader.vue?vue&type=template&id=59a2fe5c&scoped=true&lang=pug&"
import script from "./ImagePopinHeader.vue?vue&type=script&lang=js&"
export * from "./ImagePopinHeader.vue?vue&type=script&lang=js&"
import style0 from "./ImagePopinHeader.vue?vue&type=style&index=0&id=59a2fe5c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a2fe5c",
  null
  
)

export default component.exports